export const HOW_IT_WORKS = "howItWorks"

export const CALC_MENU = "calcMenu"

export const REVIEWS = "reviews"

export const DELIVERY = "delivery"

export const ORDER = "order"
